import { gql } from "@apollo/client";

export const GET_STUDENT_DETAILS = gql`
  query get_student_details($id: ID!) {
    user(id: $id) {
      id
      first_name
      last_name
      document
      document_type
      mobile
      email
      is_self_registered
      address
      city {
        id
        name
      }
       state {
        id
        name
       }
      country {
        id
        name
      }
      resumes{
        id
        resume_name
        resume_type
        is_inhouse_resume
      }
      is_personal_information_complete
      certifications
      co_curricular
      dob
      gender
      # roles
      qualification {
        id
        qualification {
          id
          name
        }
        course {
          id
          name
        }
        graduation_year
        specialization
        college_percentage
        # enrolment_number
        # transcripts
        # current
        college
      }
      language {
        language
        read
        write
        speak
      }
      # certifications
      skills
      profile
      job_details {
        job_title
        job_location
        created_at
        job_status
        job_type
      }
      title_preference
      work_preference {
        id
        industry_id
        functional_area_id
        functional_area {
           id
           name
         }
         industry {
           id
           name
         }
        job_functional_area_preferences
        job_industry_preferences
        job_city_preferences
        job_type_1
        job_type_2
        job_location
         job_state {
           id
           name
         }
         job_city {
           id
           name
         }
        minimum_expectation
        maximum_expectation
         internship_industry_id
         internship_functional_area_id
         internship_functional_area {
           id
           name
         }
         internship_industry {
           id
           name
         }
        internship_functional_area_preferences
        internship_industry_preferences
        internship_city_preferences
        internship_job_type_1
        internship_job_type_2
        internship_job_location
         internship_state {
           id
           name
         }
         internship_city {
           id
           name
         }
        internship_minimum_expectation
        internship_maximum_expectation
      }
      work_experience {
        id
        current
        designation
        company
        functional_area {
          id
          name
        }
        industry {
          id
          name
        }
        start_date
        end_date
        description
      }
      internship_experience {
        id
        company
        functional_area {
          id
          name
        }
        industry {
          id
          name
        }
        start_date
        end_date
        designation
        description
      }
      # co_curricular
      # location
      faculty_recommendation
      # video_name
      college {
        name
      }
      personal_details
      mafoi_score
      education
      # workexperience
      skill_section
      training
      summary
      extra
    }
  }
`;

export const GET_STUDENT_DETAILS_FOR_EMPLOYER = gql`
  query view_candidate_profile($id: ID!) {
    view_candidate_profile(id: $id) {
      status
      message
      user {
        id
        first_name
        last_name
        document
        document_type
        mobile
        email
        is_self_registered
        address
        city {
          id
          name
        }
        # state {
        #   id
        #   name
        # }
        country {
          id
          name
        }
        dob
        gender
        # roles
        qualification {
          id
          qualification {
            id
            name
          }
          course {
            id
            name
          }
          graduation_year
          specialization
          college_percentage
          # enrolment_number
          # transcripts
          # current
          college
        }
        language {
          language
          read
          write
          speak
        }
        # certifications
        skills
        profile
        job_details {
          job_title
          job_location
          created_at
          job_status
          job_type
        }
        title_preference
        work_preference {
          id
          # industry_id
          # functional_area_id
          # functional_area {
          #   id
          #   name
          # }
          # industry {
          #   id
          #   name
          # }
          job_functional_area_preferences
          job_industry_preferences
          job_city_preferences
          job_type_1
          job_type_2
          job_location
          # job_state {
          #   id
          #   name
          # }
          # job_city {
          #   id
          #   name
          # }
          minimum_expectation
          maximum_expectation
          # internship_industry_id
          # internship_functional_area_id
          # internship_functional_area {
          #   id
          #   name
          # }
          # internship_industry {
          #   id
          #   name
          # }
          internship_functional_area_preferences
          internship_industry_preferences
          internship_city_preferences
          internship_job_type_1
          internship_job_type_2
          internship_job_location
          # internship_state {
          #   id
          #   name
          # }
          # internship_city {
          #   id
          #   name
          # }
          internship_minimum_expectation
          internship_maximum_expectation
        }
        work_experience {
          id
          current
          designation
          company
          functional_area {
            id
            name
          }
          industry {
            id
            name
          }
          start_date
          end_date
          description
        }
        internship_experience {
          id
          company
          functional_area {
            id
            name
          }
          industry {
            id
            name
          }
          start_date
          end_date
          designation
          description
        }
        # co_curricular
        # location
        faculty_recommendation
        # video_name
        college {
          name
        }
        personal_details
        mafoi_score
        education
        # workexperience
        skill_section
        training
        summary
        extra
      }
    }
  }
`;

export const GET_STUDENT_DETAILS_FOR_RESUME_BUILDER = gql`
  query get_student_details_for_resume_builder($id: ID!) {
    user(id: $id) {
      id
      first_name
      last_name
      mobile
      email
      personal_details
      city{
      id
      name
      }
      state{
      id
      name
      }
      mafoi_score
      education
      workexperience
      skill_section
      training
      summary
      extra
    }
  }
`;

export const GET_MES_RESUME_SECTIONS = gql`
  query get_resume_mes_sections {
    get_resume_mes_sections {
      status
      message
      mafoi_score
      assessments {
        name
        code
        score
        sections {
          name
          score
          code
          is_included
          color
        }
      }
    }
  }
`;

// $file: Upload
// $resume: Upload

export const UPDATE_STUDENT_PROFILE = gql`
  mutation update_student($input: UpdateUserInput!) {
    update_user(input: $input) {
      status
      error
    }
  }
`;

export const GET_PROFILE_PHOTO = gql`
  query get_profile_picture {
    get_profile_picture {
      photo_url
    }
  }
`;

export const UPLOAD_PROFILE_PHOTO = gql`
  mutation upload_profile_picture($input: UploadProfilePictureInput!) {
    upload_profile_picture(input: $input) {
      status
      error
    }
  }
`;

export const GET_VIDEO_INTRODUCTION = gql`
  query get_video_introduction($user_id: ID!) {
    get_video_introduction(user_id: $user_id) {
      file
      file_type
      file_name
      video_upload_date
    }
  }
`;

export const UPLOAD_VIDEO_INTRODUCTION = gql`
  mutation upload_video_introduction($input: UploadVideoIntroductionInput!) {
    upload_video_introduction(input: $input) {
      status
      error
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation change_password($input: ChangePasswordInput!) {
    change_password(input: $input) {
      status
      error
    }
  }
`;

export const GET_COLLEGE_LOGO = gql`
  query get_campus_logo {
    campus_logo {
      document
      document_type
      document_name
    }
  }
`;

export const GET_USER_ASSESSMENTS = gql`
  query user_assessments {
    get_user_assessments {
      user_assessments
    }
  }
`;

export const UPLOAD_VIDEO_INTRO = gql`
  mutation upload_video_intro($input: UploadVideoIntroduction) {
    upload_video_intro(input: $input) {
      status
      error
    }
  }
`;
